import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.css']
})
export class MainNavComponent implements OnInit {

  @Input() showMainNav: boolean = true;

  currUser: any = {
    name: {
      full: {
        first: 'Hello',
        last: ''
      }
    }
  };

  constructor(
    private _authService: AuthService
  ) {

  }

  ngOnInit() {
    let localUser = this._authService.getUser();
    this.currUser = localUser ? localUser : this.currUser;
  }

}



// WEBPACK FOOTER //
// ./src/app/main-nav/main-nav.component.ts